import { useEffect } from 'react';
import './App.less';
import { HashRouter, Route, Routes } from 'react-router-dom';
import { UsuariosProvider } from './common/contexts/UsuariosContext';

import LoginPage from './usuarios/pages/LoginPage';
import UnidadesProduccionList from './unidades-produccion/UnidadesProduccionList';
import RequireAuth from './usuarios/components/RequireAuth';
import EquiposRadarList from './equipos/EquiposList';
import UnidadProduccionSave from './unidades-produccion/UnidadProduccionSave';
import RenombrarPage from './lotes-renombrado/pages/RenombrarPage';
import UsuarioSave from './usuarios/pages/UsuarioSave';
import UsuariosList from './usuarios/pages/UsuariosList';
import HomePage from './home/HomePage';
import Notify from './common/components/Notify';
import { AppStateProvider } from './common/contexts/AppStateContext';
import AsignarRenombradoPage from './infracciones/pages/AsignarRenombradoPage';
import CargarConsultaPage from './lotes-consulta/pages/CargarConsultaPage';
import VerificarPage from './lotes-verificacion/pages/VerificarPage';
import LotesConsultaList from './lotes-consulta/pages/LotesConsultaList';
import EquiposRadarSave from './equipos/EquipoSave';
import AgentesList from './agentes/AgentesList';
import AgenteSave from './agentes/AgenteSave';
import LotesExportacionList from './lotes-exportacion/LotesExportacionList';
import LotesRenombradoList from './lotes-renombrado/pages/LotesRenombradoList';
import CodigoInfraccionList from './codigos-infraccion/CodigosInfraccionList';
import CodigoInfraccionSave from './codigos-infraccion/CodigoInfraccionSave';
import LotesPrecargaList from './lotes-precarga/LotesPrecargaList';
import InfraccionesList from './infracciones/pages/InfraccionesList';
import LotesVerificacionList from './lotes-verificacion/pages/LotesVerificacionList';
import LotesImpresionList from './lotes-impresion/LotesImpresionList';
import EstadisticasPage from './estadisticas/EstadisticasPage';
import EventosList from './eventos/EventosList';
import ConfiguracionesProduccionList from './configuraciones-produccion/ConfiguracionesProduccionList';
import ConfiguracionProduccionSave from './configuraciones-produccion/ConfiguracionProduccionSave';
import ConsultaJuzgadoList from './juzgado/pages/ConsultaJuzgadoList';
import ConfiguracionAnaliticaSave from './configuraciones-analitica/pages/ConfiguracionAnaliticaSave';
import ConfiguracionesAnaliticaList from './configuraciones-analitica/pages/ConfiguracionesAnaliticaList';
import EquiposProcesamientoList from './equipos-procesamiento/EquiposProcesamientoList';
import EquipoProcesamientoSave from './equipos-procesamiento/EquipoProcesamientoSave';
import GenerarConvenio from './convenios-pago/pages/GenerarConvenio';
import ConveniosPagoConfiguracionSave from './convenios-pago-configuraciones/ConveniosPagoConfiguracionSave';
import ConveniosPagoConfiguracionesList from './convenios-pago-configuraciones/ConveniosPagoConfiguracionesList';
import ConveniosPagoList from './convenios-pago/pages/ConveniosPagoList';
import CargarRendicionesPage from './correo/pages/CargarRendicionesPage';
import Regenerar from './lotes-impresion/RegenerarConsultaPage';
import JuzgadoConfiguracionSave from './juzgado-configuraciones/JuzgadoConfiguracionSave';
import JuzgadoConfiguracionList from './juzgado-configuraciones/JuzgadoConfiguracionList';
import JuzgadoList from './juzgado/pages/JuzgadoList';
import ListarInfractores from './callCenter/pages/ListarInfractores';
import DetalleInfracciones from './callCenter/pages/DetalleInfracciones';
import LibreDeuda from './juzgado/pages/LibreDeuda';
import Estadisticas from './dashboard/Estadisticas';
import EnvioEmailPage from './notificaciones/EnvioEmailPage';
import EnvioPostalPage from './notificaciones/EnvioPostalPage';
import GenerarLoteEmailPage from './notificaciones/GenerarLoteEmailPage';

const App = () => {

  useEffect(() => {
    document.title = process.env.REACT_APP_NAME!;
  }, [])

  return (
    <HashRouter basename={process.env.REACT_APP_BASENAME}>
      <AppStateProvider>
        <UsuariosProvider>
          <Notify>
            <Routes >

              <Route path="/" element={
                <RequireAuth>
                  <HomePage />
                </RequireAuth>
              } />

              <Route path="/login" element={<LoginPage />} />

              {/* Equipos de procesamiento */}
              <Route path="/neuralvision/equipos-procesamiento" element={
                <RequireAuth>
                  <EquiposProcesamientoList />
                </RequireAuth>
              } />
              <Route path='/neuralvision/equipos-procesamiento/guardar'
                element={
                  <RequireAuth>
                    <EquipoProcesamientoSave />
                  </RequireAuth>
                }
              />
              <Route path='/neuralvision/equipos-procesamiento/guardar/:id'
                element={
                  <RequireAuth>
                    <EquipoProcesamientoSave />
                  </RequireAuth>
                }
              />


              {/* Configuraciones analitica */}
              <Route path="/neuralvision/configuraciones-analitica" element={
                <RequireAuth>
                  <ConfiguracionesAnaliticaList />
                </RequireAuth>
              } />
              <Route path='/neuralvision/configuraciones-analitica/guardar'
                element={
                  <RequireAuth>
                    <ConfiguracionAnaliticaSave />
                  </RequireAuth>
                }
              />
              <Route path='/neuralvision/configuraciones-analitica/guardar/:id'
                element={
                  <RequireAuth>
                    <ConfiguracionAnaliticaSave />
                  </RequireAuth>
                }
              />

              {/* Unidades de producción */}
              <Route path="/unidades-produccion" element={
                <RequireAuth>
                  <UnidadesProduccionList />
                </RequireAuth>
              } />
              <Route path="/unidades-produccion/guardar" element={
                <RequireAuth>
                  <UnidadProduccionSave />
                </RequireAuth>
              } />
              <Route path="/unidades-produccion/guardar/:id" element={
                <RequireAuth>
                  <UnidadProduccionSave />
                </RequireAuth>
              } />

              {/* Configuraciones de producción */}
              <Route path="/configuraciones-produccion" element={
                <RequireAuth>
                  <ConfiguracionesProduccionList />
                </RequireAuth>
              } />
              <Route path="/configuraciones-produccion/guardar" element={
                <RequireAuth>
                  <ConfiguracionProduccionSave />
                </RequireAuth>
              } />
              <Route path="/configuraciones-produccion/guardar/:id" element={
                <RequireAuth>
                  <ConfiguracionProduccionSave />
                </RequireAuth>
              } />

              {/* Usuarios */}
              <Route path="/usuarios/guardar" element={
                <RequireAuth>
                  <UsuarioSave />
                </RequireAuth>
              } />
              <Route path="/usuarios/guardar/:id" element={
                <RequireAuth>
                  <UsuarioSave />
                </RequireAuth>
              } />
              <Route path="/usuarios" element={
                <RequireAuth>
                  <UsuariosList />
                </RequireAuth>
              } />

              {/* Renombrado */}
              <Route path="/lotes-renombrado" element={
                <RequireAuth>
                  <LotesRenombradoList />
                </RequireAuth>
              } />
              <Route path="/lotes-renombrado/asignar" element={
                <RequireAuth>
                  <AsignarRenombradoPage />
                </RequireAuth>
              } />
              <Route path="/lotes-renombrado/renombrar/:unidadProduccion/:equipo/:year/:month/:day" element={
                <RequireAuth>
                  <RenombrarPage />
                </RequireAuth>
              } />
              <Route path="/lotes-renombrado/renombrar/:unidadProduccion/:equipo/:year/:month" element={
                <RequireAuth>
                  <RenombrarPage />
                </RequireAuth>
              } />
              <Route path="/lotes-renombrado/renombrar/:unidadProduccion/:equipo/:year" element={
                <RequireAuth>
                  <RenombrarPage />
                </RequireAuth>
              } />
              <Route path="/lotes-renombrado/renombrar/:unidadProduccion/:equipo" element={
                <RequireAuth>
                  <RenombrarPage />
                </RequireAuth>
              } />
              <Route path="/lotes-renombrado/renombrar" element={
                <RequireAuth>
                  <RenombrarPage />
                </RequireAuth>
              } />



              {/* Consulta */}
              <Route path="/lotes-consulta" element={
                <RequireAuth>
                  <LotesConsultaList />
                </RequireAuth>
              } />
              <Route path="/lotes-consulta/cargar" element={
                <RequireAuth>
                  <CargarConsultaPage />
                </RequireAuth>
              } />

              {/* Verificacion */}

              <Route path="/verificacion" element={
                <RequireAuth>
                  <LotesVerificacionList />
                </RequireAuth>
              } />
              <Route path="/verificacion/:lote" element={
                <RequireAuth>
                  <VerificarPage />
                </RequireAuth>
              } />
              <Route path="/verificacion/:lote/:unidadProduccion/:equipo" element={
                <RequireAuth>
                  <VerificarPage />
                </RequireAuth>
              } />
              <Route path="/verificacion/:lote/:unidadProduccion/:equipo/:year" element={
                <RequireAuth>
                  <VerificarPage />
                </RequireAuth>
              } />
              <Route path="/verificacion/:lote/:unidadProduccion/:equipo/:year/:month" element={
                <RequireAuth>
                  <VerificarPage />
                </RequireAuth>
              } />
              <Route path="/verificacion/:lote/:unidadProduccion/:equipo/:year/:month/:day" element={
                <RequireAuth>
                  <VerificarPage />
                </RequireAuth>
              } />


              {/* Equipos */}
              <Route path="/equipos" element={
                <RequireAuth>
                  <EquiposRadarList />
                </RequireAuth>
              } />
              <Route path="/equipos/guardar" element={
                <RequireAuth>
                  <EquiposRadarSave />
                </RequireAuth>
              } />
              <Route path="/equipos/guardar/:id" element={
                <RequireAuth>
                  <EquiposRadarSave />
                </RequireAuth>
              } />


              {/* Estadisticas */}
              <Route path="/estadisticas" element={
                <RequireAuth>
                  <EstadisticasPage />
                </RequireAuth>
              } />

              {/* Eventos */}
              <Route path="/eventos" element={
                <RequireAuth>
                  <EventosList />

                </RequireAuth>
              } />

              {/* Infracciones */}
              <Route path="/infracciones" element={
                <RequireAuth>
                  <InfraccionesList />
                </RequireAuth>
              } />

              {/* Agentes */}
              <Route path="/agentes" element={
                <RequireAuth>
                  <AgentesList />
                </RequireAuth>
              } />
              <Route path="/agentes/guardar" element={
                <RequireAuth>
                  <AgenteSave />
                </RequireAuth>
              } />
              <Route path="/agentes/guardar/:id" element={
                <RequireAuth>
                  <AgenteSave />
                </RequireAuth>
              } />

              {/* Lotes exportación */}
              <Route path="/lotes-exportacion" element={
                <RequireAuth>
                  <LotesExportacionList />
                </RequireAuth>
              } />


              {/* Códigos infracción */}
              <Route path="/codigos-infraccion" element={
                <RequireAuth>
                  <CodigoInfraccionList />
                </RequireAuth>
              } />
              <Route path="/codigos-infraccion/guardar" element={
                <RequireAuth>
                  <CodigoInfraccionSave />
                </RequireAuth>
              } />
              <Route path="/codigos-infraccion/guardar/:id" element={
                <RequireAuth>
                  <CodigoInfraccionSave />
                </RequireAuth>
              } />
              {/* Equipos de procesamiento */}
              <Route path="/dashboard" element={
                <RequireAuth>
                  <Estadisticas />
                </RequireAuth>
              } />
              {/* Configuración */}
              {/*
             <Route path="/configuracion" element={
              <RequireAuth>
                <ConfiguracionSave />
              </RequireAuth>
            } />
             */}


              {/*Precarga */}
              <Route path="/precarga/lotes" element={
                <RequireAuth>
                  <LotesPrecargaList />
                </RequireAuth>
              } />


              {/* Lotes impresión */}
              <Route path="/lotes-impresion" element={
                <RequireAuth>
                  <LotesImpresionList />
                </RequireAuth>
              } />
              <Route path = "/lotes-impresion/regenerar" element = {
              <RequireAuth>
                <Regenerar />
              </RequireAuth>
              }/>

              {/* Juzgado */}

              <Route path="/juzgado-consulta" element={
                <RequireAuth>
                  {/* <ConsultaJuzgadoList /> */}
                  <JuzgadoList />
                </RequireAuth>
              } />

              <Route path="/juzgado/libre-deuda" element={
                <RequireAuth>
                  <LibreDeuda/>                  
                </RequireAuth>
              } />

              {/* Convenios de pago */}
              <Route path='/convenios-pago' element={
                <RequireAuth>
                  <ConveniosPagoList />
                </RequireAuth>
              } />

              <Route path='/convenios-pago/infractores' element={
                <RequireAuth>
                  <GenerarConvenio />
                </RequireAuth>
              } />

              {/* Configuraciones de convenios de pago */}
              <Route path='/convenios-pago/configuraciones' element={
                <RequireAuth>
                  <ConveniosPagoConfiguracionesList />
                </RequireAuth>
              } />

              <Route path='/convenios-pago/configuraciones/guardar' element={
                <RequireAuth>
                  <ConveniosPagoConfiguracionSave />
                </RequireAuth>
              } />

              <Route path='/convenios-pago/configuraciones/guardar/:id' element={
                <RequireAuth>
                  <ConveniosPagoConfiguracionSave />
                </RequireAuth>
              } />

              <Route path='/callCenter/infractores' element={
                <RequireAuth>
                  <ListarInfractores />
                </RequireAuth>
              } />

              <Route path='/callCenter/detalleInfracciones' element={
                <RequireAuth>
                  <DetalleInfracciones />
                </RequireAuth>
              } />

              {/* Correo */}
              <Route path='/correo/correo-argentino/cargar-rendiciones' element={
                <RequireAuth>
                  <CargarRendicionesPage />
                </RequireAuth>
              } />

              {/* Configuraciones de Juzgado */}
              <Route path='/juzgado/configuraciones' element={
                <RequireAuth>
                  <JuzgadoConfiguracionList />
                </RequireAuth>
              } />

              <Route path='/juzgado/configuraciones/guardar' element={
                <RequireAuth>
                  <JuzgadoConfiguracionSave />
                </RequireAuth>
              } />
              <Route path='/juzgado/configuraciones/guardar/:id' element={
                <RequireAuth>
                  <JuzgadoConfiguracionSave />
                </RequireAuth>
              } />
               <Route path='/notificaciones/email' element={
                <RequireAuth>
                  <EnvioEmailPage />
                </RequireAuth>
              } />
                <Route path='/notificaciones/email' element={
                <RequireAuth>
                  <EnvioEmailPage />
                </RequireAuth>
              } />
               <Route path='/notificaciones/postal' element={
                <RequireAuth>
                  <EnvioPostalPage />
                </RequireAuth>
              } />
               <Route path='/notificaciones/lote-email' element={
                <RequireAuth>
                  <GenerarLoteEmailPage />
                </RequireAuth>
              } />

            </Routes>
          </Notify>
        </UsuariosProvider>
      </AppStateProvider>
    </HashRouter>
  )
};

export default App;